import * as React from 'react';
import { cn } from '../../utils';
import { LucideIcon } from 'lucide-react';

interface EmptyStateAction { label: string; onClick: () => void }

interface EmptyStateProps extends React.HTMLAttributes<HTMLDivElement> {
  icon?: LucideIcon;
  title: string;
  description: string;
  action?: EmptyStateAction;
}

export function EmptyState({ icon: Icon, title, description, action, className, ...props }: EmptyStateProps) {
  return (
    <div
      className={cn(
        'flex flex-col items-center justify-center py-12 px-6 text-center',
        'border-2 border-dashed border-border rounded-[16px]',
        className
      )}
      {...props}
    >
      {Icon && (
        <div className="relative mb-4">
          <Icon className="w-12 h-12 text-foreground opacity-[0.05]" strokeWidth={1} />
          <Icon className="absolute inset-0 w-12 h-12 text-muted-foreground/40" strokeWidth={1.5} />
        </div>
      )}
      <p className="text-[13px] font-semibold text-foreground mb-1">{title}</p>
      <p className="text-[12px] text-muted-foreground max-w-xs leading-relaxed">{description}</p>
      {action && (
        <button
          onClick={action.onClick}
          className="mt-4 px-3.5 py-2 rounded-[10px] bg-primary text-primary-foreground text-[12px] font-medium hover:bg-primary/90 transition-colors"
        >
          {action.label}
        </button>
      )}
    </div>
  );
}
